import { connect } from 'react-redux';

import ApplicationSummary from '../../../../ApplicationSummary';
import { applicantStatusTypes } from '../../../../../constants/statusConstants';

const { INVITED, COMPLETED } = applicantStatusTypes;

function mapStateToProps(state) {
  const { rentalApplication = {} } = state;
  const { currentApplication = {} } = rentalApplication;
  const { applicantsData = [] } = currentApplication;
  const applicants = applicantsData.map((applicant) => {
    const {
      userId,
      applicationId,
      zgAuthZone,
      submittedTime,
      contactInfo,
      idVerificationInfo,
      screeningReportShareInfo,
      backgroundInfo,
      creditInfo,
      questionMap,
      invitedTime,
    } = applicant;

    const isComplete = applicant.statusType === COMPLETED.id;
    const isNotStarted = applicant.statusType === INVITED.id;

    if (isComplete) {
      return {
        userId,
        applicationId,
        zgAuthZone,
        submittedTime,
        isComplete,
        isNotStarted,
        backgroundInfo,
        creditInfo,
        idVerificationInfo,
        screeningReportShareInfo,
        ...questionMap,
      };
    } else {
      return {
        invitedTime,
        isComplete,
        isNotStarted,
        contactInfo,
        ...questionMap, // this will only contain first and last names - see RE-16241
      };
    }
  });

  return {
    applicants,
  };
}

const ApplicationSummaryContainer = connect(mapStateToProps)(ApplicationSummary);

export default ApplicationSummaryContainer;
